import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const addTopic = createAsyncThunk('addTopic', async (data) => {
    try {
        const payload = {
            "subject_id": data?.values?.subjectId,
            "course_id": data?.values?.courseId,
            "topic_name": data?.values?.topicName,
            "description": data?.values?.description,
            "status": data?.values?.status || "Active"
        };
        // institute_id is resolved server-side from the actor's own session for institute-tier
        // and Test Designer accounts - only send it when the form actually collected it
        // (company-level actor picking manually).
        if (data?.values?.instituteId) payload.institute_id = data.values.instituteId;

        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'topic',
            data: payload,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
